import { Rule } from "antd/es/form";
import { regexpInn, regexpPhone, regexpSumm } from "../RegexpConstants";

export const ruleSummMinMax: Rule = {
  pattern: regexpSumm,
  message: "Сумма от 0 и до 100 млрд",
};

export const ruleBaseCommission: Rule = {
  min: 890,
  message: "Тариф банка не может быть меньше 890 рублей",
};

export const ruleRequired: Rule = {
  required: true,
  message: "Обязательное поле",
};

export const rulePhone: Rule = {
  pattern: regexpPhone,
  message: "Введите действующий телефонный номер",
};

export const ruleInn: Rule = {
  pattern: regexpInn,
  message: "Введите существующий ИНН",
};

export const ruleText: Rule = {
  max: 200,
  message: "Не должно быть больше 200 символов",
};
